import ctl from '@netlify/classnames-template-literals';

export const wrapperStyle = ctl(`
  fixed 
  inset-0
  flex-center
  bg-gunmetal/80
`);

export const modalStyle = ctl(`
  w-full 
  max-w-[500px] 
  min-w-[400px]
  bg-white 
  p-6
`);

export const headerStyle = ctl(`
  flex-center-between 
  mb-4
`);

export const titleStyle = ctl(`
  flex items-center
  text-xl 
  font-semibold
`);
